import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Gift } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "./Reveal";

const brl = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: Number.isInteger(v) ? 0 : 2 }).format(v);

// Selo da home para clientes antigos: só aparece quando o lojista definiu um bônus maior que zero.
export const TradeBonusBadge = () => {
  const [amount, setAmount] = useState(0);
  useEffect(() => {
    api.get("/trade-bonus").then((r) => setAmount(Number(r?.data?.amount) || 0)).catch(() => setAmount(0));
  }, []);
  if (!(amount > 0)) return null;
  return (
    <section data-testid="home-trade-bonus" className="mx-auto max-w-[1440px] px-5 pb-10 sm:px-8 sm:pb-14">
      <Reveal>
        <Link data-testid="home-trade-bonus-link" to="/troca"
          className="group flex flex-col gap-4 rounded-[28px] border border-emerald-400/30 bg-emerald-400/[0.07] p-5 transition-colors hover:border-emerald-400/60 sm:flex-row sm:items-center sm:justify-between sm:p-6">
          <span className="flex items-center gap-4">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-emerald-400 text-black"><Gift className="h-5 w-5" /></span>
            <span>
              <span className="block text-xs font-semibold uppercase tracking-[0.2em] text-emerald-300">Comprou na RC?</span>
              <span data-testid="home-trade-bonus-text" className="font-display mt-1 block text-xl font-bold tracking-tight text-white sm:text-2xl">Ganhe {brl(amount)} de bônus na troca</span>
            </span>
          </span>
          <span className="inline-flex shrink-0 items-center gap-2 text-sm font-semibold text-emerald-200">
            Avaliar meu aparelho <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </span>
        </Link>
      </Reveal>
    </section>
  );
};
